type Props = {
	children: React.ReactNode;
};

export const SidebarV2Main = ( { children }: Props ) => {
	return <div className="sidebar-v2__main">{ children }</div>;
};
